<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(company.id)" v-if="company.id && $can('company-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-combobox
                  name="company.name"
                  v-model="company.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('companies.name')"
                  :error-messages="errors.collect('company.name')"
                  :items="organisations"
                  item-text="text"
                  item-value="vat"
                  :search-input.sync="orgNameSearch"
                  @change="updateOrgVat"
                  autocomplete="new-password"
                  clearable
                >
                  <template v-slot:append>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:append-item>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:item="{ index, item }"> {{ item.text }} ({{ item.vat }}) </template>
                </v-combobox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="company.vat"
                  v-model="company.vat"
                  class="required-field"
                  v-validate="'required|max:9'"
                  :label="$t('companies.vat')"
                  :error-messages="errors.collect('company.vat')"
                  @keypress="$keyDown_IntOnly($event)"
                  :append-outer-icon="'sync'"
                  @click:append-outer="searchOrgByVat(company.vat)"
                  :hint="$t('global.helptext_vat')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="company.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("companies.company_access") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <router-link :to="BACKEND_URL + '/users/account/create?query_company_id=' + company.id + '&query_action=add-to-company-access'">
              <action-button type="new" />
            </router-link>
            <!--<action-button type="new" @click="showUserListPopupModal" small />-->
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="companyaccess_headers"
                  :items="usersaccess"
                  :items-per-page="usersaccess.length"
                  :options.sync="ua_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="ua_total"
                  :loading="ua_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.first_name="{ item }">
                    <router-link :to="{ path: BACKEND_URL + '/users/view/' + item.user_id, props: { id: item.user_id } }">
                      {{ item.user.person.first_name }}
                    </router-link>
                  </template>
                  <template v-slot:item.last_name="{ item }">
                    <router-link :to="{ path: BACKEND_URL + '/users/view/' + item.user_id, props: { id: item.user_id } }">
                      {{ item.user.person.last_name }}
                    </router-link>
                  </template>
                  <template v-slot:item.issued_date="{ item }">
                    {{ moment.utc(item.issued_date).format(DATE_FORMAT) }}
                  </template>
                  <template v-slot:item.active_until="{ item }"> {{ moment.utc(item.active_until).format(DATE_FORMAT) }} </template>4
                  <template v-slot:item.actions="{ item }">
                    <router-link
                      :to="{ path: BACKEND_URL + '/users/account/edit/' + item.user_id, props: { id: item.user_id } }"
                      v-if="$can('user-access')"
                    >
                      <action-button small type="edit" :icon_only="true" :text="$t('users.view_details')" :icon="'fas fa-eye'" />
                    </router-link>
                    <action-button
                      type="delete"
                      :icon_only="true"
                      @click="deleteUserAccess(item.user_id, item.company_id)"
                      v-if="$can('company-access')"
                      small
                    />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="company.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("companies.employees") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <router-link
              :to="BACKEND_URL + '/users/account/create?query_company_id=' + company.id + '&query_action=add-to-employee-access'"
            >
              <action-button type="new" />
            </router-link>
            <!--<action-button type="new" @click="showUserListPopupModal" small />-->
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="employees_headers"
                  :items="employees"
                  :items-per-page="employees.length"
                  :options.sync="emp_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="emp_total"
                  :loading="emp_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.first_name="{ item }">
                    <router-link :to="{ path: BACKEND_URL + '/users/view/' + item.user_id, props: { id: item.user_id } }">
                      {{ item.user.person.first_name }}
                    </router-link>
                  </template>
                  <template v-slot:item.last_name="{ item }">
                    <router-link :to="{ path: BACKEND_URL + '/users/view/' + item.user_id, props: { id: item.user_id } }">
                      {{ item.user.person.last_name }}
                    </router-link>
                  </template>
                  <template v-slot:item.issued_date="{ item }">
                    {{ moment.utc(item.issued_date).format(DATE_FORMAT) }}
                  </template>
                  <template v-slot:item.active_until="{ item }"> {{ moment.utc(item.active_until).format(DATE_FORMAT) }} </template>4
                  <template v-slot:item.actions="{ item }">
                    <router-link
                      :to="{ path: BACKEND_URL + '/users/account/edit/' + item.user_id, props: { id: item.user_id } }"
                      v-if="$can('user-access')"
                    >
                      <action-button small type="edit" :icon_only="true" :text="$t('users.view_details')" :icon="'fas fa-eye'" />
                    </router-link>
                    <action-button
                      type="delete"
                      :icon_only="true"
                      @click="deleteUserAccess(item.user_id, item.company_id)"
                      v-if="$can('company-access')"
                      small
                    />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="company.id">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("companies.requested_access") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="pending_headers"
                  :items="pendingrequests"
                  :items-per-page="pendingrequests.length"
                  :options.sync="req_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="req_total"
                  :loading="req_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.first_name="{ item }">
                    {{ item.user.person.first_name }}
                  </template>
                  <template v-slot:item.last_name="{ item }">
                    {{ item.user.person.last_name }}
                  </template>
                  <template v-slot:item.mobile="{ item }">
                    {{ item.user.person.mobile }}
                  </template>
                  <template v-slot:item.email="{ item }">
                    {{ item.user.email }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <action-button small type="approve" :icon_only="true" @click="approve(item.user_id, item.company_id)" />
                    <action-button small type="reject" :icon_only="true" @click="reject(item.user_id, item.company_id)" />
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>

    <userListPopup
      :key="reRenderUserListPopup"
      :show="showUserListPopup"
      @callback_user_select="callback_user_select"
      @callback_user_cancel="callback_user_cancel"
    />
  </v-container>
</template>

<script>
import _ from "lodash"
import userListPopup from "@/modules/users/components/partials/UserListPopup.vue"

export default {
  name: "CompanyForm",

  props: ["id", "modal"],

  components: {
    userListPopup
  },

  data() {
    return {
      page_title: "",
      predata: {},
      company: {
        name: ""
      },

      organisations: [],
      orgNameSearch: null,

      showUserListPopup: false,
      reRenderUserListPopup: 0,

      pendingrequests: [],
      req_total: 0,
      req_show_loading: false,
      req_show_filter: false,
      req_refresh: false,
      req_pagination: {
        page: this.$getLocalStorage("__page_Company_UserRequest_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      usersaccess: [],
      ua_total: 0,
      ua_show_loading: false,
      ua_show_filter: false,
      ua_refresh: false,
      ua_pagination: {
        page: this.$getLocalStorage("__page_Company_UserAccess_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["user_id"]
      },
      ua_search_params: {
        any: ""
      },

      employees: [],
      emp_total: 0,
      emp_show_loading: false,
      emp_show_filter: false,
      emp_refresh: false,
      emp_pagination: {
        page: this.$getLocalStorage("__page_Company_Employee_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["user_id"]
      },
      emp_search_params: {
        any: ""
      },

      dictionary: {
        attributes: {
          "company.name": this.$t("companies.name"),
          "company.vat": this.$t("companies.vat")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.company, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    pending_headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "email" },
          { text: this.$t("users.mobile"), value: "mobile" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    companyaccess_headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "user.email" },
          { text: this.$t("users.mobile"), value: "user.person.mobile" },
          { text: this.$t("companies.issued_date"), value: "issued_date" },
          { text: this.$t("companies.active_until"), value: "active_until" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    employees_headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "user.email" },
          { text: this.$t("users.mobile"), value: "user.person.mobile" },
          { text: this.$t("companies.issued_date"), value: "issued_date" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  watch: {
    req_refresh: {
      handler() {
        if (this.req_refresh) {
          this.usersaccess_pending_list()
        }
      }
    },
    req_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Company_UserRequest_List", newVal.page)
          }

          this.req_refresh = true
        }
      }
    },
    ua_refresh: {
      handler() {
        if (this.ua_refresh) {
          this.usersaccess_approved_list()
        }
      }
    },
    ua_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Company_UserAccess_List", newVal.page)
          }

          this.ua_refresh = true
        }
      }
    },
    emp_refresh: {
      handler() {
        if (this.emp_refresh) {
          this.employees_list()
        }
      }
    },
    emp_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Company_Employee_List", newVal.page)
          }

          this.emp_refresh = true
        }
      }
    },
    orgNameSearch: {
      handler: _.debounce(function(search) {
        if (search) {
          this.searchOrgVatByName(search)
        } else {
          this.organisations = []
        }
      }, 300)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("companies.new_company")

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.company))
    } else {
      this.title = this.$t("companies.update_title")

      axios
        .get(this.API_URL + "company/" + this.id)
        .then((res) => {
          this.company = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.company))

          // Load organisations dropdown from BRREG
          this.searchOrgByVat(this.company.vat, true)

          this.page_title = this.$t("companies.edit_company", {
            name: this.company.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    usersaccess_pending_list() {
      this.req_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.req_pagination
      let query = this.$queryString(this.req_pagination, { company_id: this.company.id, status: 2 })

      axios
        .get(this.API_URL + "usercompaniesaccess" + "?" + query)
        .then((res) => {
          this.pendingrequests = res.data.data
          this.req_total = res.data.meta.total
          this.req_refresh = false
          this.req_show_loading = false

          this.req_pagination.page = res.data.meta.current_page
          this.req_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    usersaccess_approved_list() {
      if (this.company.id) {
        this.ua_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.ua_pagination
        let query = this.$queryString(this.ua_pagination, { ...this.ua_search_params, company_id: this.company.id, status: 1 })

        axios.get(this.API_URL + "usercompaniesaccess?" + query).then((res) => {
          this.usersaccess = res.data.data
          this.ua_total = res.data.meta.total
          this.ua_refresh = false
          this.ua_show_loading = false

          this.ua_pagination.page = res.data.meta.current_page
          this.ua_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },
    employees_list() {
      if (this.company.id) {
        this.emp_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.emp_pagination
        let query = this.$queryString(this.emp_pagination, { ...this.emp_search_params, company_id: this.company.id, status: 1 })

        axios.get(this.API_URL + "usercompaniesemployees?" + query).then((res) => {
          this.employees = res.data.data
          this.emp_total = res.data.meta.total
          this.emp_refresh = false
          this.emp_show_loading = false

          this.emp_pagination.page = res.data.meta.current_page
          this.emp_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.company.id) {
              // Create
              axios
                .post(this.API_URL + "company", {
                  name: this.company.name,
                  vat: this.company.vat,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.company = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.company))

                      vm.page_title = vm.$t("companies.edit_company", {
                        name: vm.company.name
                      })
                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/companies/edit/${vm.company.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "company", {
                  id: this.company.id,
                  name: this.company.name,
                  vat: this.company.vat
                })
                .then((res) => {
                  vm.company = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.company))

                  vm.page_title = vm.$t("companies.edit_company", {
                    name: vm.company.name
                  })

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "company/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/companies")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    approve(user_id, company_id) {
      let vm = this

      this.$awn.confirm(
        this.$t("companies.confirm_approve_request"),
        () => {
          axios
            .post(this.API_URL + "company/request/approve", {
              user_id: user_id,
              company_id: company_id
            })
            .then((res) => {
              vm.$awn.success(vm.$t("companies.approve_success"))
              vm.ua_refresh = true
              vm.req_refresh = true
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    reject(user_id, company_id) {
      let vm = this

      this.$awn.confirm(
        this.$t("companies.confirm_reject_request"),
        () => {
          axios
            .post(this.API_URL + "company/request/reject", {
              user_id: user_id,
              company_id: company_id
            })
            .then((res) => {
              vm.$awn.success(vm.$t("companies.reject_success"))
              vm.ua_refresh = true
              vm.req_refresh = true
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    deleteUserAccess(user_id, company_id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "usercompanyaccess/user/" + user_id + "/company/" + company_id)
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.ua_refresh = true
                vm.req_refresh = true
                vm.$awn.success(vm.$t("global.delete_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    searchOrgByVat(search, init = false) {
      let vm = this
      
      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.company, "name", companyname || null)
            this.$set(this.company, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.company, "name", null)
            vm.$set(vm.company, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.company, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.company, "vat", this.organisations.length ? this.organisations[0].vat : null)

        //       if(init) {
        //         this.predata = JSON.parse(JSON.stringify(this.company))
        //       }
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function(error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text:companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      console.log(this.company.name)
      if (this.company.name && typeof this.company.name === "object") {
        let org = this.organisations.find((i) => i.key == this.company.name.key)
        if (org) {
          this.$set(this.company, "name", org.text || null)
          this.$set(this.company, "vat", org.vat || null)
          return
        }

        // let org = this.organisations.find((i) => i.vat == this.company.name.vat)
        // if (org) {
        //   this.$set(this.company, "name", org.text)
        //   this.$set(this.company, "vat", org.vat)
        //   return
        // }
      }

      this.$set(this.company, "name", this.company.name || null)
      this.$set(this.company, "vat", null)
    },

    showUserListPopupModal() {
      this.reRenderUserListPopup++
      this.showUserListPopup = true
    },
    callback_user_select(ids) {
      let vm = this
      this.showUserListPopup = false

      this.$awn.confirm(
        this.$t("companies.confirm_add_users"),
        () => {
          axios
            .post(this.API_URL + "usercompanyaccess/add-users", {
              company_id: this.company.id,
              ids: ids.join(",")
            })
            .then((res) => {
              vm.$awn.success(vm.$t("companies.add_users_success"))
              vm.ua_refresh = true
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.no"),
            confirmOk: this.$t("global.yes")
          }
        }
      )
    },
    callback_user_cancel() {
      this.showUserListPopup = false
    }
  }
}
</script>

<style scoped></style>
